import * as React from 'react';
import { Theme, styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import ArrowCircleDownRoundedIcon from '@mui/icons-material/ArrowCircleDownRounded';
import { IconButton } from '@mui/material';


const SiteTitleLayoutRoot = styled('section')(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    height: '80vh',
    minHeight: 500,
    maxHeight: 1300,
  },
}));

const Background = styled(Box)({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  zIndex: -2,
});

interface SiteTitleLayoutProps {
  sxBackground: SxProps<Theme>;
}

export default function SiteTitleLayout(
  props: React.HTMLAttributes<HTMLDivElement> & SiteTitleLayoutProps,
) {
  const { sxBackground, children } = props;

  return (
    <SiteTitleLayoutRoot>
      <Container maxWidth={false}
        sx={{
          mt: 3,
          mb: 14,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        
      >
        {children}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'common.black',
            opacity: 0.5,
            zIndex: -1,
          }}
        />
        <Background sx={sxBackground} />
        <IconButton
            component="a"
            href="#whyus"
            color="primary"
            size='medium'
            rel="noopener noreferrer"
          >
            <ArrowCircleDownRoundedIcon />
          </IconButton>
      </Container>
    </SiteTitleLayoutRoot>
  );
}